module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "image-sider"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "0px 0px 0px 30px",
      "padding": "0px 0px 0px 0px",
      "cursor": "pointer"
    }
  }, [_c('a', {
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("< Previous")]), _vm._v(" || "), _c('a', {
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Next >")])]), _vm._v(" "), _vm._l(([_vm.currentNumber]), function(number) {
    return _c('div', {
      staticClass: "rslides"
    }, [_c('div', {
      style: ({
        position: 'relative',
        height: _vm.divHeight,
        width: _vm.divWidth
      })
    }, [_c('img', {
      style: ({
        height: _vm.imgHeight,
        width: _vm.imgWidth,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        margin: 'auto',
        cursor: 'pointer'
      }),
      attrs: {
        "src": _vm.photos[_vm.currentNumber].name
      },
      on: {
        "mouseover": _vm.stopRotation,
        "mouseout": _vm.startRotation,
        "contextmenu": _vm.disabledRightClick,
        "click": function($event) {
          return _vm.triggerDetail(_vm.photos[_vm.currentNumber].folder, _vm.photos[_vm.currentNumber].subFolder)
        }
      }
    })])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8aced388!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vueImageSlider/components/index.vue
// module id = 591
// module chunks = 2